import { useEffect } from "react";
import Header from "components/Common/Header/Header";
import MediaLibraryBody from "components/MediaLibrary/MediaLibraryBody";

const MediaLibrary = () => {
  useEffect(() => {
    document.title = "Media Library";
  }, []);

  return (
    <main id="app">
      <Header moduleName="media" />
      <MediaLibraryBody />
    </main>
  );
};

export default MediaLibrary;
